import React, { FC } from 'react';
import { VendorAddress } from '../../dto/Vendor';
import { Button, Checkbox } from 'antd';
import AddressEditModal, { useAddressEditModal } from './AddressEditModal';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { getCountryName } from '../../common/SelectEnums';
import {
  formatPhoneNumber,
  formatPhoneNumberIntl,
} from 'react-phone-number-input';

type Props = {
  linked?: boolean;
  linkedValue?: any;
  value?: VendorAddress;
  onChange?: (value: VendorAddress) => void;
};

export const VendorAddressSection: FC<Props> = (props) => {
  const modal = useAddressEditModal();
  const { value: propsValue, linkedValue, linked, onChange } = props;
  const value: VendorAddress | undefined =
    propsValue ?? (linked ? linkedValue : undefined);
  return (
    <div className="w-full flex flex-col gap-2">
      {linked && (
        <div>
          <Checkbox
            checked={value ? value.linked : linked}
            onChange={(e) => {
              if (e.target.checked) {
                onChange?.(
                  linkedValue ? { ...linkedValue, linked: true } : undefined,
                );
              } else {
                modal.current
                  ?.open(value)
                  .then((v) => onChange?.({ ...v, linked: false }))
                  .catch((e) => {
                    onChange?.(
                      linkedValue
                        ? { ...linkedValue, linked: true }
                        : undefined,
                    );
                  });
              }
            }}
          >
            Use Billing Address
          </Checkbox>
        </div>
      )}
      {!value && !linked && (
        <Button
          className="w-full"
          icon={<PlusOutlined />}
          type={'dashed'}
          onClick={() =>
            modal.current
              ?.open(value)
              .then((v) => onChange?.({ ...v, linked: false }))
              .catch((e) => {})
          }
        >
          Set Address
        </Button>
      )}
      {value && (
        <div
          className="border rounded border-solid border-gray-200 p-2 px-4 relative cursor-pointer hover:border-primary duration-300"
          onClick={() =>
            modal.current
              ?.open(value)
              .then((v) => onChange?.({ ...v, linked: false }))
              .catch((e) => {})
          }
        >
          <div>{value.attention}</div>
          {value.address?.split('\n').map((a, i) => <div key={i}>{a}</div>)}
          <div>{value.city}</div>
          <div>{value.state}</div>
          <div>{getCountryName(value.country!)}</div>
          <div>{value.zipCode}</div>
          <div>{formatPhoneNumberIntl(value.phone!)}</div>
          <div className="absolute right-0 top-0">
            <Button
              shape="circle"
              type="link"
              onClick={() => modal.current?.open(value)}
            >
              <EditOutlined />
            </Button>
          </div>
        </div>
      )}
      <AddressEditModal ref={modal} />
    </div>
  );
};
